import component from './ca-ES/component';
import globalHeader from './ca-ES/globalHeader';
import menu from './ca-ES/menu';
import pages from './ca-ES/pages';
import pwa from './ca-ES/pwa';
import settingDrawer from './ca-ES/settingDrawer';
import settings from './ca-ES/settings';

export default {
  'navBar.lang': 'Llengües',
  'layout.user.link.help': 'Ajuda',
  'layout.user.link.privacy': 'Privacitat',
  'layout.user.link.terms': 'Termes',
  'app.preview.down.block': 'Descarrega aquesta pàgina al teu projecte local',
  'app.welcome.link.fetch-blocks': 'Obtenir tots els blocs',
  'app.welcome.link.block-list':
    'Construeix ràpidament pàgines estàndard basades en el desenvolupament de blocs',
  ...globalHeader,
  ...menu,
  ...settingDrawer,
  ...settings,
  ...pwa,
  ...component,
  ...pages,
};
